import { Outlet } from '@tanstack/react-router'
import { Background } from './Background'
import { LensDefs } from '@ui/glass/LensDefs'
import { useRestaurarRolagem } from './rolagem'

/**
 * O que existe em toda rota, com sessão ou sem ela: o fundo, as definições do
 * filtro de lente e a restauração da rolagem. Os dois primeiros ficavam no
 * `AppShell`, que agora só é montado depois do login — sem esta camada, a tela
 * de entrar apareceria sobre nada.
 */
export function RootLayout() {
  // Aqui, e não no `AppShell`: o `AppShell` só existe depois do login, e a
  // restauração vale para toda rota — como o fundo logo abaixo.
  useRestaurarRolagem()

  return (
    <>
      <Background />
      <LensDefs />
      <Outlet />
    </>
  )
}
